import type { ReactNode } from 'react';
import { KindIcon } from '../parts/Icons';
import type { MediaKind } from '../../core/types';
import { Spinner } from '../parts/bits';

/** A deliberate composition for waiting, unsupported and failed previews. UI-017 */
export function StatusStage({
  kind,
  title,
  body,
  busy,
  children,
}: {
  kind: MediaKind;
  title: string;
  body?: string;
  busy?: boolean;
  children?: ReactNode;
}) {
  return (
    <div className="status-stage" role="status">
      <div className="status-stage__icon">
        <KindIcon kind={kind} />
        {busy && <Spinner />}
      </div>
      <h2 className="status-stage__title">{title}</h2>
      {body && <p className="status-stage__body">{body}</p>}
      {children}
    </div>
  );
}
